import type { QuestionWithSlide } from '@mentimeter/editor-schema/api-types-overrides';
import { typeToQuestionType } from '../../../compatibility/src/backward-compatibility/converters/static-content/type-to-question-type';
import type { ChecklistItemState } from './hooks/use-checklist-store';

// Helper function to determine if a slide is not interactive
export const isNonInteractiveSlide = (
  slide: QuestionWithSlide | undefined,
): boolean => {
  if (!slide) return false;

  return (
    slide.staticContent.type === 'free-text' ||
    slide.staticContent.type === 'instructions' ||
    typeToQuestionType(slide.staticContent.type) === 'slide'
  );
};

export const getCompletedStepsAmount = (items: ChecklistItemState[]) => {
  return items.filter((i: ChecklistItemState) => i.completed).length;
};
